import dayjs from 'dayjs';
import CreateColumn from '../../../../Services/agGrid/createColumn';

export const getColumnDefs1 = (props) => {
  return [
    CreateColumn('no', 'NO', 'right', 80, false, false, false, 'checkbox', {
      checkboxProps: {
        gridRef: props.gridRef,
        rowData: props.rowData1,
        handleRowSelection: props.handleRowSelection,
      },
      maxWidth: 80,
    }),

    CreateColumn('tbmCd', 'TBM코드', 'left', 200, false, false, true),

    CreateColumn('depNm', '소속', 'left', 150, false, false, false, 'text', {
      flex: 1,
      valueGetter: (params) => {
        const row = params.data || {};
        const internalYn = String(
          row.internalYn ?? row.InternalYn ?? row.INTERNAL_YN ?? '0'
        );
        if (internalYn === '1') {
          return (
            row.affiliationNm ?? row.AffiliationNm ?? row.AFFILIATION_NM ?? ''
          );
        }
        return row.depNm ?? row.DepNm ?? row.DEP_NM ?? '';
      },
    }),

    CreateColumn('rank', '직위', 'left', 150, false, false, false, 'text', {
      flex: 1,
    }),

    CreateColumn(
      'name',
      '근로자명',
      'left',
      200,
      false,
      false,
      false,
      'requiredButton',
      {
        flex: 1,
        buttonValueTooltip: 'TBM 실시 내역 확인',
        showEmptyButton: false,
        buttonClickHandler: (params) => {
          props.SearchLogic2({ userId: params.data.userId });
          props.setModalToggle1(true);
        },
        buttonValueStyle: {
          color: 'green',
          fontWeight: 'bold',
          cursor: 'pointer',
          textDecoration: 'underline',
          background: 'none',
          border: 'none',
          padding: 0,
        },
      }
    ),

    CreateColumn(
      'tbmAddDate',
      '총 누계시간',
      'center',
      200,
      false,
      false,
      false,
      'text',
      {
        cellClass: 'none-editable-cell',
        valueFormatter: (params) => {
          if (!params.data) return '0분';
          const seconds = Number(params.data.tbmAddDate);
          if (isNaN(seconds) || seconds === 0) return '0분';

          const minutes = Math.floor(seconds / 60);
          if (minutes <= 0) return '0분';

          const hours = Math.floor(minutes / 60);
          const remainMin = minutes % 60;

          let result = '';
          if (hours > 0) result += `${hours}시간 `;
          if (remainMin > 0) result += `${remainMin}분`;
          return result.trim();
        },
      }
    ),

    CreateColumn(
      'achievementRate',
      '달성률(%)',
      'center',
      200,
      false,
      false,
      false,
      'text',
      {
        cellClass: 'none-editable-cell',
        valueFormatter: (params) => (params.value ? `${params.value}%` : '0%'),
      }
    ),
  ];
};

export const getColumnDefs2 = (props) => {
  return [
    CreateColumn('tbmCd', 'TBM코드', 'left', 200, false, false, true),

    CreateColumn('depNm', '부서명', 'left', 150, false),

    CreateColumn('position', '직급', 'left', 100, false),

    CreateColumn('name', '근로자명', 'left', 120, false),

    CreateColumn(
      'tbmDate',
      '일자',
      'center',
      120,
      false,
      false,
      false,
      'date',
      {
        dateFormat: 'YYYY-MM-DD',
      }
    ),

    CreateColumn(
      'tbmStartDate',
      '시작시간',
      'center',
      120,
      false,
      false,
      false,
      'text',
      {
        valueFormatter: (params) =>
          params.value ? dayjs(params.value).format('HH:mm') : '',
      }
    ),

    CreateColumn(
      'tbmEndDate',
      '종료시간',
      'center',
      120,
      false,
      false,
      false,
      'text',
      {
        valueFormatter: (params) =>
          params.value ? dayjs(params.value).format('HH:mm') : '',
      }
    ),

    CreateColumn(
      'tbmAddDate',
      '실시시간(분)',
      'center',
      140,
      false,
      false,
      false,
      'text',
      {
        valueFormatter: (params) => {
          if (!params.data) return '0분';
          const seconds = Number(params.data.tbmAddDate);
          if (isNaN(seconds) || seconds <= 0) return '0분';
          const minutes = Math.floor(seconds / 60);
          if (minutes <= 0) return '0분';
          const hours = Math.floor(minutes / 60);
          const remainMin = minutes % 60;
          let result = '';
          if (hours > 0) result += `${hours}시간 `;
          if (remainMin > 0) result += `${remainMin}분`;
          return result.trim();
        },
      }
    ),

    CreateColumn(
      'totalTime',
      '누계시간',
      'center',
      150,
      false,
      false,
      false,
      'text',
      {
        valueFormatter: (params) => {
          if (!params.data) return '0분';
          const seconds = Number(
            params.value || params.data.monthlyTotalTime || 0
          );
          if (isNaN(seconds) || seconds <= 0) return '0분';
          const minutes = Math.floor(seconds / 60);
          if (minutes <= 0) return '0분';
          const hours = Math.floor(minutes / 60);
          const remainMin = minutes % 60;
          let result = '';
          if (hours > 0) result += `${hours}시간 `;
          if (remainMin > 0) result += `${remainMin}분`;
          return result.trim();
        },
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
  getColumnDefs2,
};

export default columnDefs;
